import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from '@cotyorg/ccx-atoms/Select';
import isServer from '@cotyorg/ccx-utils/js/helpers/isServer';

const mapLangsToOptionFormat = ({ langs }) => {
  const pathnameParts = !isServer ? window.location.pathname.split('/') : [];
  const locale = pathnameParts.length >= 2 ? pathnameParts[1] : undefined;

  return langs.map(lang => (
    {
      name: lang.name,
      value: lang.slug,
      isSelected: locale === lang.slug,
    }
  ));
};

const mapRegions = ({ countries }) => (
  countries
    .map(mapLangsToOptionFormat)
    .reduce((acc, curr) => acc.concat(curr), [])
);

const getLanguages = regions => (
  regions
    .map(mapRegions)
    .reduce((acc, curr) => acc.concat(curr), [])
);

const generateCountrySelectorClassNames = extraClassNames => classNames(
  'country-selector',
  extraClassNames,
);

const generateSelectClassNames = extraClassNames => classNames(
  'country-selector--simple',
  extraClassNames,
);

const redirectToLocale = (newLocale) => {
  if (!isServer) {
    const pathnameParts = window.location.pathname.split('/');
    // If less than 3 parts, there is only a locale and no rest of path so return empty string
    const pathnameWithoutLocale = pathnameParts.length >= 3 ? pathnameParts.slice(2).join('/') : '';
    window.location.assign(`/${newLocale}/${pathnameWithoutLocale}`);
  }
};

const CountrySelectorSimple = ({
  regions,
  extraClass,
  extraSelectClass,
  chevronIconSrc,
}) => (
  <div className={generateCountrySelectorClassNames(extraClass)}>
    <Select
      selectOptions={getLanguages(regions)}
      extraClass={generateSelectClassNames(extraSelectClass)}
      onChange={redirectToLocale}
      ariaLabel="countryselect"
      chevronIconSrc={chevronIconSrc}
    />
  </div>
);

CountrySelectorSimple.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    countries: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      langs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })),
    })),
  })).isRequired,
  extraClass: PropTypes.string,
  extraSelectClass: PropTypes.string,
  chevronIconSrc: PropTypes.string,
};

export default CountrySelectorSimple;
